export const enum SectionName {
  General = 'general',
  Help = 'help',
  Payment = 'payment',
  Shipping = 'shipping',
  International = 'international',
  Social = 'social',
}
